import React, { useState } from "react"
import { Box, Link, InternalIcon, Typography, Button } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { CheckInTimeIntroContainer } from "#/components/carrot-plans/check-in/CheckInTimeIntro"

export function CheckInExperienceCta({ variant = "link" }: { variant?: "link" | "button" }): JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      alignItems="start"
    >
      <>
        <Typography>
          <FormattedMessage defaultMessage="Ready for more? Answer a few questions to receive new suggestions for next steps. " />
        </Typography>
        <UpdateCarrotPlan variant={variant} />
      </>
    </Box>
  )
}

function UpdateCarrotPlan({ variant = "link" }: { variant?: "link" | "button" }): JSX.Element {
  const [toggleCheckInModalOpen, setToggleCheckInModalOpen] = useState(false)

  function openModal(event: { preventDefault: () => void }) {
    event.preventDefault()
    setToggleCheckInModalOpen(true)
  }

  const content = <FormattedMessage defaultMessage="Update Carrot Plan" />

  const VariantComponent = () => {
    if (variant === "button") {
      return (
        <Button variant="contained" color="primary" onClick={openModal}>
          {content}
        </Button>
      )
    }

    return (
      <Link
        component="button"
        textAlign="start"
        onClick={openModal}
        endIcon={<InternalIcon fontSize="small" color="primary" />}
      >
        {content}
      </Link>
    )
  }

  return (
    <>
      <VariantComponent />
      {toggleCheckInModalOpen && (
        <CheckInTimeIntroContainer origin="cta" setToggleModalFromCta={setToggleCheckInModalOpen} />
      )}
    </>
  )
}
